import React from 'react';
import Header2 from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from './../Segments/Banner';
import About2 from './../Segments/About2';
import TeamMembers2 from './../Segments/TeamMembers';
import Services from './../Segments/Services';
import Story from './../Segments/Story';

var bnrimg = require('./../../images/main-slider/slider1/Banner-1.jpg');

class AboutUs extends React.Component {
    componentDidMount (){
        window.scrollTo(0,0)
    }
    render() {
        return (
            <>
                <Header2 />
                <div className="page-content">
                    <Banner title="Building beyond boundaries: Designs that define the future." pagename="About Us" bgimage={bnrimg.default}/>
                    <About2 />
                    <TeamMembers2 />
                    <Services />
                    <Story />
                </div>

                <Footer />
            </>
        );
    };
};

export default AboutUs;